export default {
    active: true,
    seed: 14,
    skyType: "gradient",
    skyColor: "#478d54",
    horizonColor: "#b696cb",
    lighting: "distant",
    lightPosition: { x: 0, y: 2.01, z: -1 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "spikes",
    groundYScale: 4.91,
    groundTexture: "none",
    groundColor: "#2e455f",
    groundColor2: "#694439",
    dressing: "apparatus",
    dressingAmount: 7,
    dressingColor: "#657067",
    dressingScale: 20,
    dressingVariance: { x: 20, y: 20, z: 20 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "1x1",
    gridColor: "#478d54",
    shadow: false,
};
